import {
  SEARCH_ISOPEN,
  SEARCH_ISSUBMITTED,
  SEARCH_LOADING,
  SEARCH_RESET,
  SEARCH_RESULTS,
  SEARCH_VALUE
} from '../actions/search';

const initialState = {
  isOpen: false,
  isSubmitted: false,
  isLoading: false,
  value: '',
  query: '',
  results: {
    data: null,
    meta: null
  }
};

const search = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_ISOPEN:
      if (!state.isOpen) {
        document.body.classList.add('search--is-open');
      } else {
        document.body.classList.remove('search--is-open');
      }
      return {
        ...state,
        isOpen: !state.isOpen
      };

    case SEARCH_ISSUBMITTED:
      return {
        ...state,
        isSubmitted: true
      };

    case SEARCH_LOADING:
      return {
        ...state,
        isLoading: action.loading
      };

    case SEARCH_RESULTS:
      return {
        ...state,
        results: action.results
      };

    case SEARCH_VALUE:
      return {
        ...state,
        value: action.value,
        query: encodeURIComponent(action.value)
      };

    case SEARCH_RESET:
      document.body.classList.remove('search--is-open');
      return {
        ...state,
        isOpen: false
      };

    default:
      return state;
  }
};

export default search;
